import { render } from "./GhostItemsModal.vue?vue&type=template&id=7c6f8f80&scoped=true"
import script from "./GhostItemsModal.vue?vue&type=script&lang=js"
export * from "./GhostItemsModal.vue?vue&type=script&lang=js"

import "./GhostItemsModal.vue?vue&type=style&index=0&id=7c6f8f80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c6f8f80"]])

export default __exports__